import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import QuickEntry from '@/pages/home/components/QuickEntry';
import HotRanking from '@/pages/home/components/HotRanking';
import TopicSection from '@/pages/home/components/TopicSection';
import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import {
  getFeaturedArticles,
  getLatest,
  getHot,
  sortByTime,
  getArticlesByCategory,
} from '@/utils/articles';

export default function Home() {
  const featured = getFeaturedArticles();
  const latest = getLatest(6);
  const hot = getHot(6);
  const editorPicks = sortByTime(getArticlesByCategory('star')).slice(0, 3);
  const stats = [
    { label: '今日更新', value: '36', icon: 'ri-article-line' },
    { label: '热点追踪', value: '128', icon: 'ri-fire-line' },
    { label: '艺人档案', value: '540+', icon: 'ri-star-smile-line' },
  ];

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 md:-mt-14 relative z-20">
        <QuickEntry />
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-6 pt-12 md:pt-16">
        <SectionHeading
          title="最新娱乐新闻"
          subtitle="刚出炉的影视、综艺与行业动态"
          icon="ri-newspaper-line"
          moreLabel="查看全部"
          moreTo="/category/news"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-6 pt-12 md:pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <SectionHeading
              title="热门内容榜"
              subtitle="按浏览与转载热度实时排序"
              icon="ri-fire-line"
              moreLabel="更多热点"
              moreTo="/category/hot"
            />
            <HotRanking articles={hot} />
          </div>
          <div>
            <SectionHeading title="编辑推荐" icon="ri-thumb-up-line" />
            <div className="flex flex-col gap-3">
              {editorPicks.map((article) => (
                <ArticleCard key={article.id} article={article} variant="row" />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="topics" className="max-w-7xl mx-auto px-4 md:px-6 pt-12 md:pt-16 scroll-mt-20">
        <SectionHeading
          title="特别专题"
          subtitle="围绕当前热点，为你整理了成体系的深度内容"
          icon="ri-bookmark-3-line"
        />
        <TopicSection />
      </section>

      <section className="mt-14 md:mt-20 bg-background-100 border-y border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-2">
              <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
                <span className="w-6 h-[2px] bg-primary-500" />
                关于 91吃瓜
              </span>
              <h2 className="mt-3 font-heading font-black text-2xl md:text-3xl text-foreground-950 leading-tight">
                一座为娱乐爱好者准备的资讯客厅
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600 max-w-2xl">
                我们把每天发生的娱乐新闻、明星动态与网络热点重新梳理，
                用清晰的结构和轻快的阅读节奏呈现给你。无论是想快速扫一眼热搜，
                还是想深入了解一场争议的来龙去脉，91吃瓜都希望成为你打开就会读完的那一页。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  了解我们
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-background-50 text-foreground-800 border border-background-300 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  联系我们
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 lg:grid-cols-1 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg bg-background-50 border border-background-200 p-4 flex items-center gap-3"
                >
                  <span className="w-10 h-10 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <i className={`${stat.icon} text-lg`} />
                  </span>
                  <div>
                    <p className="font-heading font-black text-lg text-foreground-950 leading-none">
                      {stat.value}
                    </p>
                    <p className="mt-1 text-xs text-foreground-500 whitespace-nowrap">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}